import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormStateService } from '../../module/service-provider/add-sp-new-component/form-state.service';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';
import { Router } from '@angular/router';
import { UserService } from '../../Service/User/user.service';
import { MessageService } from 'primeng/api';
import { ToastService } from '../../Service/ToastService/toast.service';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormGroup } from '@angular/forms';
import { finalize } from 'rxjs';
import { ReloadService } from '../../Service/Reload-service/reload.service';

@Component({
  selector: 'app-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss'],
  providers: [MessageService],
})
export class CustomDialogComponent implements OnInit, OnChanges {
  @Output() closeModal = new EventEmitter<void>();
  @Output() refreshList = new EventEmitter<void>();
  @Input() title!: string;
  @Input() message!: string;
  @Input() details!: string[];
  @Output() onClose = new EventEmitter<void>();
  @Output() onApprove = new EventEmitter<void>();
  @Input() resourceType: 'USER' | 'SERVICEPROVIDER' | 'SERVICEADVISOR' | 'SERVICEDISTRIBUTOR' = 'USER';
  //@Input() model: any = { agreementFiles: [] }; 
  @Input() serviceProviderName!: string;

  subdomain!: string;
  isEditingSubdomain: boolean = false;
  serviceProviderId: any;
  serviceAdvisorId: any;
  distributorId: any;
  id: any;
  isApproved: boolean = false;
  agreementFileUrl: string = '';

  form = new FormGroup({});
  model: any = {
    agreementFiles: [],
  };

  //const fileSourceId = 3;
  fields: FormlyFieldConfig[] = [

    {
      key: 'agreementFiles',
      type: 'multifile',
      templateOptions: {
        placeholder: 'Upload Agreement Document',
        required: true,
        hideRequiredMarker: true,
        accept: '.pdf,.jpg,.png',
        fileSourceId: 7,
      },
    },
  ];


  constructor(
    private formStateService: FormStateService,
    private api: ServiceProviderService,
    private router: Router,
    private userAPI: UserService,
    private toastService: ToastService,
    private reloadService: ReloadService,
     private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    
    // const retrievedSubdomain = this.formStateService.getSubDomainName() || '';
    // // this.subdomain = `${retrievedSubdomain}.autoecare`;

    this.setSubdomain();
    console.log('ngOnInit subdomain:', this.subdomain);

    this.serviceProviderId = this.formStateService.getServiceProviderId();
    this.id = this.formStateService.getUserId();
    this.serviceAdvisorId = this.formStateService.getServiceAdvisorId();
    this.distributorId = this.formStateService.getServiceDistributorId();
    this.model.agreementFiles = this.model.agreementFiles || [];
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['serviceProviderName']) {
      this.setSubdomain();
      this.cdr.detectChanges();
      console.log('ngOnChanges subdomain:', this.subdomain);
    }
  }

  setSubdomain() {
    let subDomainFromService = this.formStateService.getSubDomainName();
    if (subDomainFromService) {
      this.subdomain = subDomainFromService;
    } else if (this.serviceProviderName) {
      this.subdomain = this.serviceProviderName.toLowerCase().replace(/\s+/g, '');
    } else {
      this.subdomain = '';
    }
  }

  approve() {
    
    this.isApproved = true;
    const data = {
      status: 3,
      message: '',
    };

    switch (this.resourceType) {
      case 'USER':
        this.userAPI.approveUser(this.id, data).subscribe(
          (res: any) => {
            this.onApprove.emit();
            this.refreshList.emit()
            this.toastService.showToast('Service Seeker Application Approved Successfully', 'success');
            this.closeDialog();
          },
          (error) => {
            this.isApproved = false;
            this.toastService.showToast('Failed to approve Service Seeker Application', 'error');
          }
        );
        break;

      case 'SERVICEADVISOR':
        this.userAPI.approveServiceAdvisor(this.serviceAdvisorId, data).subscribe(
          (res: any) => {
            this.onApprove.emit();
            this.toastService.showToast('Service Advisor Application Approved Successfully', 'success');
            this.refreshList.emit()
            this.closeDialog();
          },
          (error) => {
            this.isApproved = false;
            this.toastService.showToast('Failed to approve Service Advisor Application', 'error');
          }
        );
        break;

      case 'SERVICEPROVIDER':
        const providerData = {
          ...data,
          subDomain: this.subdomain,
        };
        this.api.approveServiceProvider(this.serviceProviderId, providerData).subscribe(
          (response: any) => {
            if (response) {
              this.onApprove.emit();
              this.toastService.showToast('Service Provider Application Approved Successfully', 'success');
              this.closeDialog();
              this.refreshList.emit();
            }
          },
          (error: any) => {
            this.isApproved = false;

            const errorMessages = error?.error?.errors;
            if (Array.isArray(errorMessages) && errorMessages.length > 0) {
              const insufficientBalanceMsg = errorMessages.find((msg: string) =>
                msg.includes('Insufficient wallet balance')
              );
              if (insufficientBalanceMsg) {
                this.toastService.showToast(insufficientBalanceMsg, 'error');
              } else {
                this.toastService.showToast(errorMessages[0], 'error');
              }
            } else {
              this.toastService.showToast('Failed to approve Service Provider Application', 'error');
            }
          }

        );
        break;

      case 'SERVICEDISTRIBUTOR':
        this.isApproved = true;

        console.log('Agreement Files:', this.model.agreementFiles);
        const uploadedFile = this.model.agreementFiles[0];
        this.formStateService.setApproveData('agreementFile', uploadedFile);

        console.log('Uploaded Agreement File:', uploadedFile);

        this.agreementFileUrl = this.model.agreementFiles[0].filePath;
        console.log('Agreementfileurl:', this.agreementFileUrl);

        const distributorData = {
          fileId: uploadedFile,
          //fileId: uploadedFile.fileId,
          status: 3,

        };

        console.log(distributorData);
        this.api.changeDistributorStatus(this.distributorId, distributorData).subscribe(
          (res: any) => {
            this.refreshList.emit();
            this.closeModal.emit();
            this.toastService.showToast('Distributor Approved Successfully', 'success');
            this.reloadService.triggerReload();
          },
          (error) => {
            this.isApproved = false;
            this.toastService.showToast('Failed to approve Distributor', 'error');
          }
        );
        break;

      default:
        console.log('Invalid resource type');
        break;
    }
  }


  edit() {
    console.log('ABC');
  }

  closeDialog() {
    this.closeModal.emit();
  }

  toggleEditSubdomain() {
    this.isEditingSubdomain = !this.isEditingSubdomain;
  }

  saveSubdomain() {
    const trimmedSubdomain = this.subdomain.replace('.autoecare', '');
    this.formStateService.setSubDomainName(trimmedSubdomain);
    this.isEditingSubdomain = false;
    this.subdomain = `${trimmedSubdomain}.autoecare.com`;
  }
}
